<template>
    <div class="div-discount">
        <Alert type="warning">
            <span>
                Atenção, a exclusão é <b>permanente</b> e não poderá ser revertida!
            </span>
        </Alert>
        <div class="div-apply text-center">
            <Button _key="btnRemove" title="Remover" color="white" backGroundColor="#EF4444" size="medium"
                :clicked="remove" />
        </div>
    </div>
</template>

<script>
import Alert from "@nixweb/nixloc-ui/src/component/layout/Alert";
import Button from "@nixweb/nixloc-ui/src/component/forms/Button";

import { mapActions, mapMutations } from "vuex";

export default {
    name: "RemoveItem",
    props: ["item", "operational"],
    components: { Alert, Button },
    data() {
        return {
            urlDelete: `/api/v1/rental/items-rent/delete${this.operational ? '-operational' : ''}`,
        };
    },
    methods: {
        ...mapActions("generic", ["deleteAllApi"]),
        ...mapMutations("generic", ["addEvent", "removeLoading", "hideModal"]),
        remove() {
            let params = {
                url: this.urlDelete,
                selected: [this.item.id],
            };
            this.deleteAllApi(params).then((response) => {
                if (response.success) {
                    this.addEvent({
                        name: "updateTotalizationRent",
                    });
                    this.hideModal();
                }
                this.removeLoading(["btnRemove"]);
            });
        },

    }
};
</script>

<style scoped>
.div-apply {
    margin-top: 15px;
}

.div-discount {
    display: grid;
    gap: 10px;
}

.sd-wrap {
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 8px;
    align-items: center;
}

.sd-mode {
    display: inline-flex;
    border: 1px solid #e5e7eb;
    border-radius: 10px;
    overflow: hidden;
}

.sd-chip {
    padding: 6px 12px;
    border: none;
    background: #fff;
    cursor: pointer;
    font-weight: 700;
}

.sd-chip+.sd-chip {
    border-left: 1px solid #e5e7eb;
}

.sd-chip.active {
    background: #ef4444;
    color: #fff;
}
</style>
